// extracted by mini-css-extract-plugin
module.exports = {"button":"styles_button__mlOCd","list":"styles_list__2gl0i"};